import styled from 'styled-components';

export const PageRoot = styled.div`
  width: 100%;
  min-height: 100vh;

  ${props =>
    props.centered
      ? `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `
      : ''}

  background: ${props =>
    props.primary
      ? props.theme.palette.primary
      : props.theme.palette.background};

  color: ${props =>
    props.primary ? props.theme.palette.white : props.theme.palette.text};
`;
